import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./modelStoreModule";

export default function useModel() {

    // Table Handlers
  const tableColumns = ref([
    {
      key: 'user',
      label: 'пользователь',
    },
    {
      key: 'permission',
      label: 'разрешение',
    },
  ])

  const setupData = {
      formModel: [],
  }

  const extraFilters = ref({})


  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`
  const deleteDataUrl = `${STORE_MODULE_NAME}/delete`

  return {

    addDataUrl,
    fetchDataUrl,
    deleteDataUrl,

    tableColumns,
    setupData,
    extraFilters
  }
}
